import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ContactEvent } from 'src/app/_models/contact-event';
import * as _ from 'lodash';

export interface AlertDialogData {
    title: string;
    message: string;
    yesButton: string;
    noButton: string;
}

@Component({
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    message: string;
    yesButton: string;
    noButton: string;

    constructor(public dialogRef: DialogRef<boolean>, @Inject(DIALOG_DATA) public data: AlertDialogData) { }

    ngOnInit(): void {
        this.title = this.data.title;
        this.message = this.data.message;
        this.yesButton = this.data.yesButton ?? 'Yes';
        this.noButton = this.data.noButton ?? 'No';
    }

    onCancel() {
        this.dialogRef.close(false);
    }

    onOk() {
        this.dialogRef.close(true);
    }
}
